/**
 * hook de busca de itens similares (pesquisas anteriores do mesmo tenant).
 */

import { useQuery } from '@tanstack/react-query';
import type { ItensSimilaresResponse } from '@licita-mind/shared-types';
import { apiFetch } from '../lib/api';

export const useSimilares = (itemId: string | undefined, limit = 5) =>
  useQuery({
    queryKey: ['similares', itemId, limit],
    queryFn: () =>
      apiFetch<ItensSimilaresResponse>(`/v1/itens/${itemId}/similares?limit=${limit}`),
    enabled: !!itemId,
    staleTime: 30_000,
  });
